import { ChangeEvent } from 'react';
import { Control, Controller } from 'react-hook-form';
import { ErrorComponent } from './ErrorComponent';
import { IForm } from '../NewRequestPopUp';
import {
  CommentsContainer,
  CommentsLabel,
  TextFieldStyle,
} from './styles/CommentController.styled';

interface CommentControllerProps {
  control: Control<IForm>;
}

export const CommentController = ({ control }: CommentControllerProps) => {
  return (
    <Controller
      name="employeeComment"
      control={control}
      render={({
        field: { onChange, onBlur, name: fieldName, value },
        fieldState: { error },
      }) => (
        <CommentsContainer>
          <CommentsLabel htmlFor="employeeComment">Comments</CommentsLabel>
          <TextFieldStyle
            id="employeeComment"
            onChange={(event) =>
              onChange(event as ChangeEvent<HTMLTextAreaElement>)
            }
            value={value}
            onBlur={onBlur}
            name={fieldName}
            rows={8}
            multiline
            resizable={false}
            placeholder="Add additional comments..."
            styles={{
              fieldGroup: { border: 'none' },
            }}
          />
          <ErrorComponent error={error} />
        </CommentsContainer>
      )}
    />
  );
};
